<template>
    <div>
        <el-row :gutter="30">
            <el-col :span="6" class="sidebar">
                <router-link :to="{name: 'Add News'}">
                    <el-button type="primary" class="fluid">{{ $t('add') }} News <i class="el-icon-plus"></i>
                    </el-button>
                </router-link>
                <ListFilterComponent @setFilter="setFilter"
                                     :selectedFilters="filters.selected"
                                     :listFilters="filters.available">
                </ListFilterComponent>
            </el-col>
            <el-col class="box" :span="18">
                <div class="list__header">
                    <p class="list__title">
                        {{ getRouteName($route) }}
                    </p>
                    <search-list-form v-model="filters.selected.search"
                                      @submit="fetchData"/>
                </div>
                <el-table :data="data"
                          highlight-current-row
                          v-loading="listLoading"
                          class="list__table"
                          style="width: 100%;">
                    <el-table-column prop="id" label="id" width="80"/>
                    <el-table-column prop="title_pl" label="tytuł (pl)"/>
                    <el-table-column prop="title_en" label="tytuł (en)"/>
                    <el-table-column prop="hide" label="ukryte">
                        <template slot-scope="scope">
                            <i class="el-icon-check" v-if="scope.row.hide"></i>
                            <i class="el-icon-close" v-else></i>
                        </template>
                    </el-table-column>
                    <el-table-column prop="slug" label="slug"/>
                    <el-table-column label="akcje" width="150" class="pull-right">
                        <template slot-scope="scope" class="pull-right">
                            <router-link :to="{name: 'Edit News', params: {id: scope.row.id}}">
                                <el-button size="small" :title="$t('edit')">
                                    <i class="el-icon-edit"></i>
                                </el-button>
                            </router-link>
                            <el-button type="danger"
                                       size="small"
                                       :title="$t('delete')"
                                       @click="handleDelete(scope.$index, scope.row)"><i
                                    class="el-icon-delete"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-col :span="24" class="list__pagination">
                    <el-pagination layout="prev, pager, next"
                                   @current-change="handleNewsChange"
                                   :page-size="pageSize" :total="count">
                    </el-pagination>
                </el-col>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import ListFilterComponent from '@/components/ListFilterComponent'
    import {News} from '@/api'

    export default {
        data () {
            return {
                filters: {
                    available: [],
                    selected: {}
                },
                data: [],
                count: 0,
                page: 1,
                pageSize: 100,
                listLoading: false,
                service: News
            }
        },
        methods: {
            handleNewsChange (val) {
                this.page = val;
                this.fetchData();
            },
            setFilter (filter) {
                this.page = 1
                const key = filter.query_param
                const value = filter.value
                this.$set(this.filters.selected, key, value)
                this.fetchData()
            },
            fetchData () {
                let params = {
                    page: this.page,
                    ...this.filters.selected
                };
                this.listLoading = true;
                this.service.fetch({}, {params}).then(response => {
                    this.count = response.data.count;
                    this.pageSize = response.data.page_size;
                    this.data = response.data.results;
                    this.listLoading = false;
                })
            },
            async handleDelete (index, row) {
                await this.$confirm(this.$i18n.t('deleteConfirmation'), this.$i18n.t('delete'), {
                    type: 'warning'
                })

                this.listLoading = true;
                try {
                    await this.service.delete({id: row.id})
                    this.$message({
                        message: 'Element został usunięty',
                        type: 'success'
                    })
                } catch (error) {
                    this.$message({
                        message: 'Wystąpił bład podczas usuwania elementu.',
                        type: 'error'
                    })
                }

                this.listLoading = false
                this.fetchData()
            }
        },
        mounted () {
            this.fetchData()
        },
        components: {
            ListFilterComponent
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// NewsList.vue?ea9b9c08